import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "./pages/Home";
import SolutionsAtlas from "./pages/SolutionsAtlas";
import ReelLibrary from "./pages/ReelLibrary";
import ReelDetail from "./pages/ReelDetail";
import LiveFeed from "./pages/LiveFeed";
import LivePoster from "./pages/LivePoster";
import LiveVision from "./pages/LiveVision";
import SystemsInMotion from "./pages/SystemsInMotion";
import Playbooks from "./pages/Playbooks";
import Knowledge from "./pages/Knowledge";
import Article from "./pages/Article";
import Careers from "./pages/Careers";
import Position from "./pages/Position";
import Contact from "./pages/Contact";
import Scoper from "./pages/Scoper";
import Admin from "./pages/Admin";
import KoshLanding from "./pages/KoshLanding";
import CaseStudyDetail from "./pages/CaseStudyDetail";
import PolicyPage from "./pages/PolicyPage";

import SideNavRail from "./components/SideNavRail";
import TopNav from "./components/TopNav";
import Footer from "./components/Footer";
import AICopilotFab from "./components/AICopilotFab";
import CookieConsent from "./components/CookieConsent";
import PageViewTracker from "./components/PageViewTracker";
import ScrollToTop from "./components/ScrollToTop";
import { ThemeProvider } from "./lib/theme";

function App() {
  useEffect(() => {
    document.title = "Wisewit — AI systems for industrial execution";
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <ThemeProvider>
        <BrowserRouter>
          <ScrollToTop />
          <PageViewTracker />
          <SideNavRail />
          <TopNav />
          <main className="md:pl-20">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/solutions" element={<SolutionsAtlas />} />
              <Route path="/reels" element={<ReelLibrary />} />
              <Route path="/reels/:slug" element={<ReelDetail />} />
              <Route path="/live" element={<LiveFeed />} />
              <Route path="/live/poster" element={<LivePoster />} />
              <Route path="/live-vision" element={<LiveVision />} />
              <Route path="/systems" element={<SystemsInMotion />} />
              <Route path="/playbooks" element={<Playbooks />} />
              <Route path="/knowledge" element={<Knowledge />} />
              <Route path="/knowledge/:slug" element={<Article />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/careers/:id" element={<Position />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/scoper" element={<Scoper />} />
              <Route path="/kosh" element={<KoshLanding />} />
              <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
              <Route path="/legal/:slug" element={<PolicyPage />} />
              <Route path="/admin" element={<Admin />} />
              {/* Role-based consoles open at /<roleSlug> (e.g. /hr). Static routes
                  above always win, so this only catches unknown single-segment paths. */}
              <Route path="/:roleSlug" element={<Admin />} />
            </Routes>
            <Footer />
          </main>
          <AICopilotFab />
          <CookieConsent />
          <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: '#121212', color: '#F5F5F5', border: '1px solid #2A2A2A', borderRadius: 0 } }} />
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
